export default "__VITE_ASSET__CZQ3_oC1__"